module.exports = __webpack_public_path__ + "img/join_content_4.184d2b3e.png";